import BaseService from './base.service';

export default class AccountDeletionService {
    static ENDPOINT = '/account-deletion';

    /**
     * Super-admin-only audit list — the most recent `account_deletions` records (every type,
     * source and status), newest first. The collection is API-only, so it can't be read from
     * Firestore directly.
     */
    static async getHistory() {
        return BaseService.get(this.ENDPOINT);
    }

    /**
     * Super-admin-only, immediate and permanent account deletion — no 30-day window.
     * The backend re-verifies `email` matches the target user's own email server-side
     * before deleting anything (the UI's typed confirmation is a courtesy, not the guard).
     */
    static async purgeImmediately(uid, email) {
        return BaseService.post(`${this.ENDPOINT}/${uid}/purge-immediately`, { email });
    }

    /**
     * Super-admin-only deletion of ONLY the identity verification (ID photos + verified flag);
     * the account stays. Same server-side `email` re-verification as purgeImmediately.
     */
    static async deleteVerification(uid, email) {
        return BaseService.post(`${this.ENDPOINT}/${uid}/delete-verification`, { email });
    }
}
